var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.80044 10.5H11.2007C11.2857 10.4997 11.3691 10.4762 11.4418 10.432C11.5145 10.3878 11.5738 10.3246 11.6133 10.2492C11.6528 10.1737 11.671 10.0889 11.666 10.0038C11.661 9.9188 11.6329 9.83674 11.5848 9.76649L7.38464 3.68899C7.21057 3.437 6.79149 3.437 6.61695 3.68899L2.41683 9.76649C2.36822 9.83659 2.33971 9.91869 2.3344 10.0039C2.3291 10.0891 2.3472 10.1741 2.38674 10.2497C2.42628 10.3253 2.48575 10.3886 2.55869 10.4327C2.63162 10.4769 2.71524 10.5001 2.80044 10.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartArrow);
export default __webpack_public_path__ + "static/media/chart-arrow.c2c3c5bb.svg";
export { ForwardRef as ReactComponent };